/**
 * 巡检点位管理接口
 */

const prefix = '/dseWeb'
export default [
  // 查询列表（分页）
  { name: 'getInspectionPointPage', url: `${prefix}/v1/op/inspectionPoint/page`, method: 'post' },
  // 新增或修改
  { name: 'insertOrUpdateInspectionPoint', url: `${prefix}/v1/op/inspectionPoint/insertOrUpdate`, method: 'post' },
  // 查询单个详情
  { name: 'getInspectionPointInfo', url: `${prefix}/v1/op/inspectionPoint/info`, method: 'get' },
  // 删除
  { name: 'deleteInspectionPoint', url: `${prefix}/v1/op/inspectionPoint/delete`, method: 'get' },
  // 获取巡检点位二维码
  { name: 'getInspectionPointQrCode', url: `${prefix}/v1/op/inspectionPoint/qrCode`, method: 'get' },
  // 批量二维码下载
  { name: 'batchQrCodeDownload', url: `${prefix}/v1/op/inspectionPoint/batchQrCodeDownload`, method: 'post' },
  // 导入模板下载
  { name: 'pointTemplate', url: `${prefix}/v1/op/inspectionPoint/pointTemplate`, method: 'get' },
  // 导入巡检点位
  { name: 'batchImport', url: `${prefix}/v1/op/inspectionPoint/batchImport`, method: 'post' }
]